export const isExpired = (expiry, expiryMarginMs) => expiry - Date.now() - expiryMarginMs <= 0;
